<template>
  <div class="settings-wrapper">
    <h5 class="settings-title settings-header">
      <slot></slot>
    </h5>
    <settings-tab-selection
      class="settings-top-menu settings-header"
      :currentTab="currentTab"
      @input="tabSelected"
      :items="filteredSettingsTabs()"
      :team="team"
      :key="settingTabs[settingTabs.length - 1].name + (team ? team.teamId : '')"
    />
    <component class="selected-tab" :is="currentTab.component" :team="team" :key="currentTab.component + (team ? team.teamId : '')" />
  </div>
</template>

<script>
import User from '@/components/User'
import SettingsTabSelection from '@/components/Settings/SettingsTabSelection'
import UserProfileSettings from '@/components/Settings/Tabs/UserProfileSettings'
import PreferencesSettings from '@/components/Settings/Tabs/PreferencesSettings'
import NotificationsSettings from '@/components/Settings/Tabs/NotificationsSettings'
import WorkplacesSettings from '@/components/Settings/Tabs/WorkplacesSettings'
import TeamGeneralSettings from '@/components/Settings/Tabs/TeamGeneralSettings'
import TeamWorkScheduleSettings from '@/components/Settings/Tabs/TeamWorkScheduleSettings'
import TeamWorkplacesSettings from '@/components/Settings/Tabs/TeamWorkplacesSettings'
import TeamMembersSettings from '@/components/Settings/Tabs/TeamMembersSettings'
import TeamIntegrationsSettings from '@/components/Settings/Tabs/TeamIntegrationsSettings'
const TeamBilling = () => import(/* webpackChunkName: 'TeamBilling' */ '@/components/Settings/Tabs/TeamBilling')

export default {
  components: {
    SettingsTabSelection,

    UserProfileSettings,
    PreferencesSettings,
    NotificationsSettings,
    WorkplacesSettings,

    TeamGeneralSettings,
    TeamWorkScheduleSettings,
    TeamWorkplacesSettings,
    TeamMembersSettings,
    TeamIntegrationsSettings,
    TeamBilling,
  },
  mixins: [User],
  props: {
    settingTabs: Array,
    team: Object,
    initialTab: Object,
  },
  data() {
    return {
      tab: null,
    }
  },
  async created() {
    this.tab = this.initialTab || this.settingTabs[0]
  },
  methods: {
    filteredSettingsTabs() {
      // filter billing for non-owners
      if (this.team && !this.team.roles.includes('owner')) {
        return this.settingTabs.filter(tab => tab.component !== 'TeamBilling')
      } else {
        return this.settingTabs
      }
    },
    tabSelected(tab) {
      this.tab = tab
    },
  },
  computed: {
    currentTab() {
      return this.tab
    },
    /* currentTab: {
            get: function () {
                return this.tab
            },
            set: function (v) {
                this.tab = v
            },
        }*/
  },
  watch: {
    initialTab: function(newVal, oldVal) {
      this.tab = newVal
    },
  },
}
</script>

<style lang="scss" scoped>
@include respond-above(sm) {
  .settings-wrapper {
    display: grid;
    grid-template-rows: 70px 76px auto;
    grid-template-columns: auto;
    height: 100%;

    .settings-header {
      background-color: #ffffff;
      width: 100%;
      z-index: 5;

      &.settings-title {
        grid-row: 1;
        grid-column: 1;

        background-color: #ffffff;
        padding: 23px 270px 23px 18px;
        margin: 0 0 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &.settings-top-menu {
        grid-row: 2;
        grid-column: 1;
        border-top: 1px solid $athens-gray;
        border-bottom: 1px solid $athens-gray;
        overflow-x: auto;
        overflow-y: hidden;
      }
    }

    .selected-tab {
      grid-row: 3;
      grid-column: 1;
      height: 100%;
      overflow-y: auto;
      padding-bottom: 120px;
    }
  }
}

@include respond-below(sm) {
  .settings-wrapper {
    /*position: fixed;
        left: 40%;
        transform: translate(-40%);*/

    //width: 322px;
    display: grid;
    grid-template-rows: auto auto auto;
    width: auto;
    //grid-template-columns: auto;
    //grid-template-columns: auto;

    .settings-header {
      background-color: #ffffff;
      width: 100%;

      &.settings-title {
        grid-row: 1;
        grid-column: 1;

        place-self: center;

        width: 100%;
        padding: 23px 18px 23px 26px;
        margin: 0 0 0 0;
        z-index: 1;
      }

      &.settings-top-menu-wrapper {
        grid-row: 2;
        grid-column: 1;
      }
    }

    .selected-tab {
      grid-row: 3;
      grid-column: 1;
      margin-bottom: 200px;
    }
  }
}

.settings-title {
  @include respond-below(sm) {
    display: none;
  }
  //grid-row: 1;

  //align-self: center; // in the center (vertically) of its cell

  @include font-rule('averta-bold');
  color: #000000;
  font-size: 20px;
  line-height: 20px;

  /*height: 35px;
   width: 100%;
   padding: 23px 18px 23px 18px;
   margin-top: 0;*/

  /*position: relative;
    z-index: 1;
    background-color: #FFFFFF;*/
  /* border-bottom: 1px solid $athens-gray;*/
}
</style>
